
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { CruiseInfoSection } from './components/CruiseInfoSection';
import { CruiseExploreSection } from './components/CruiseExploreSection';
import { NewsletterSection } from './components/NewsletterSection';
import { DestinationsSection } from './components/DestinationsSection';
import { DealsSection } from './components/DealsSection';
import { ContactSection } from './components/ContactSection';

const CruisesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <CruiseInfoSection />
        <CruiseExploreSection />
        <NewsletterSection />
        <DestinationsSection />
        <DealsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default CruisesPage;
